import { TableField } from "../../table-field";

const numeroEdital: TableField = {
  key: "NrEdital",
  label: "Número Edital",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const ano: TableField = {
  key: "AnoEdital",
  label: "Ano",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const banca: TableField = {
  key: "Banca",
  label: "Banca",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const tipo: TableField = {
  key: "Tipo",
  label: "Tipo",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const situacao: TableField = {
  key: "Situacao",
  label: "Situação",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const dtInicio: TableField = {
  key: "DtInicioInscricao",
  label: "Início Inscrição",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const dtFim: TableField = {
  key: "DtFimInscricao",
  label: "Fim Inscrição",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const ugResponsavel: TableField = {
  key: "NomeUgResponsavel",
  label: "UG Responsável",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: true,
};
const actions = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const fieldsEditais: TableField[] = [
  numeroEdital,
  ano,
  banca,
  tipo,
  situacao,
  dtInicio,
  dtFim,
  actions,
];

export const fieldsEditaisSead: TableField[] = [
  numeroEdital,
  ano,
  banca,
  tipo,
  situacao,
  dtInicio,
  dtFim,
  ugResponsavel,
  actions,
];
